// deps
import React, { memo, useContext } from "react";

// internal deps
import { OtherPaymentOffersGroup } from "@swiggy-private/payment-ui";

// interfaces
import { PreferredGroupHandlerProps } from "@payment-client/components/show-payments/components/payment-group-handler/interfaces";

// hooks
import { usePreferredHandler } from "@payment-client/components/show-payments/components/payment-group-handler/hooks/UsePreferredHandler";
import { ShowPaymentContext } from "@payment-client/contexts/ShowPaymentContext";
import { isWalletGroup } from "@payment-client/helpers/WalletHelper";

function OtherPaymentGroupHandler(props: PreferredGroupHandlerProps): React.ReactElement | null {
    const { onSelect, onPay, paymentGroup, ...otherProps } = props;
    const preferredProps = usePreferredHandler(props);
    const { paymentResponse } = useContext(ShowPaymentContext);
    const walletGroupData = paymentResponse?.paymentGroup.find(group => isWalletGroup(group));

    return <OtherPaymentOffersGroup {...otherProps} {...preferredProps} walletGroupData={walletGroupData} />;
}

export default memo(OtherPaymentGroupHandler);
